import { EColors, EFonts } from 'libs/styles/styling';
import { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    label: string;
    value: string;
    autoComplete?: string;
    autoFocus?: boolean;
    placeholder?: string;
    type?: string;
    onChange?: (value: string) => void;
    onBlur?: () => void;
    className?: string;
}

export const TextInputLight = (props: Props): JSX.Element => {
    const [value, setValue] = useState<string>(props.value);

    useEffect(() => {
        if (props.value !== value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <S_TextInputLight className={props.className}>
            {props.label && <S_Label>{props.label}</S_Label>}
            <S_Input
                value={value}
                autoComplete={props.autoComplete}
                autoFocus={props.autoFocus}
                onChange={(e) => {
                    setValue(e.target.value);
                    if (props.onChange) {
                        props.onChange(e.target.value);
                    }
                }}
                type={props.type ?? 'text'}
                onBlur={props.onBlur}
            />
        </S_TextInputLight>
    );
};

export const S_TextInputLight = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const S_Input = styled.input`
    border-radius: 7px;
    font-family: ${EFonts.Regular};
    padding: 10px 15px;
    font-size: 15px;
    color: ${EColors.DARK};
    min-width: 45px;
    resize: none;
    outline: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    border: 1px solid #8286a2;
    background: #fff;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
    &:focus {
        transform: scale(1.05);
    }
`;

const S_Label = styled.div`
    color: ${EColors.DARK};
    font-size: 13px;
    margin: 0 0 12px 0;
    font-family: ${EFonts.Medium};
`;
